import { Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { NavTabBar } from '@asad/crane-ui'

/** Zakładki konta użytkownika. Ustawienia profilu mają własny pasek zakładek,
 *  więc `/profile/settings` celowo zostaje poza tym layoutem — inaczej ekran
 *  dostałby dwa paski jeden nad drugim. */

const PROFILE_TABS = [
  { to: '/profile', labelKey: 'profile.tabs.overview', match: (pathname: string) => pathname === '/profile' },
  { to: '/profile/documents', labelKey: 'profile.tabs.documents' },
]

const ProfileLayout = () => {
  const { pathname } = useLocation()
  const { t } = useTranslation()

  return (
    <div className='crane-ui-surface flex flex-col gap-3.5 text-crane-foreground'>
      <NavTabBar
        items={PROFILE_TABS.map((tab) => ({ to: tab.to, label: t(tab.labelKey), match: tab.match }))}
        pathname={pathname}
      />

      <div className='flex flex-col gap-3.5'>
        <Outlet />
      </div>
    </div>
  )
}

export { ProfileLayout }
export default ProfileLayout
